export function CandidatsActions({ children, selectedItems, onDeselectAll }) {}
